import ApiService from '../base/BaseApiService';
import { DOCUMENT_TYPE } from '../../utils/insuranceTypeUtils';
import { normalizeSpaces } from '../../utils/common';

/**
 * 文書種別コードとElasticsearchの `index_type` の対応表。
 *
 * @type {Record<string, string>}
 */
const AUTOCOMPLETE_INDEX_TYPE = {
  [DOCUMENT_TYPE.NEW_CONTRACT]: 'new_contract',
  [DOCUMENT_TYPE.MAINTENANCE]: 'maintenance',
  [DOCUMENT_TYPE.HANDBOOK]: 'handbook',
  [DOCUMENT_TYPE.HIKIUKE]: 'hikiuke',
};

/**
 * 画面上の文書種別・タブ種別を、サジェストAPIの index_type に変換する。
 * しおり約款は生保/損保で別インデックスを使う。
 *
 * @param {string} documentType 文書種別コード
 * @param {'life'|'sonpo'|string} activeTab 現在のタブ
 * @returns {string} APIに渡す `index_type`。解決できない場合は空文字
 */
const resolveIndexType = (documentType, activeTab) => {
  if (documentType === DOCUMENT_TYPE.POLICY_BOOKLET) {
    return activeTab === 'sonpo' ? 'policy_booklet_songai' : 'policy_booklet_seimei';
  }
  if (documentType === DOCUMENT_TYPE.ALL) {
    return activeTab === 'sonpo' ? 'all_songai' : 'all_seimei';
  }
  return AUTOCOMPLETE_INDEX_TYPE[documentType] || '';
};

/**
 * Elasticsearchのオートコンプリート候補を取得する。
 *
 * @param {string} query 入力中の検索キーワード
 * @param {string} documentType 文書種別コード
 * @param {'life'|'sonpo'|string} activeTab 現在のタブ
 * @param {number} size 取得件数
 * @returns {Promise<string[]>} 候補文字列の配列
 */
export const fetchAutocompleteSuggestions = async (query, documentType, activeTab, size) => {
  const normalizedQuery = normalizeSpaces(query).trim();
  if (!normalizedQuery || !documentType || normalizedQuery.length > 100) {
    return [];
  }

  // index_type への変換はService内で完結させ、呼び出し元にAPIパラメータを露出しない
  const indexType = resolveIndexType(documentType, activeTab);
  if (!indexType) {
    return [];
  }

  const response = await ApiService.get(
    '/elasticsearch/autocomplete',
    { query: normalizedQuery, index_type: indexType, size },
    { showErrorDialog: false, timeout: 10000 }
  );

  // レスポンス仕様: { suggestions: string[] }
  return Array.isArray(response?.suggestions) ? response.suggestions : [];
};
